// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__z1OAw","info":"Note_info__3wcAh","note":"Note_note__37uB6","actions":"Note_actions__3hR4h"};